import React, { Component, useEffect } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Dropdown, Icon, Menu, Modal, notification, Popover } from "antd";
import axios from "axios";
import moment from "moment";

import { GlobalContext } from "../../../app/providers/GlobalState";

import { escola, sair } from "../../../assets/menu";
import { logo_stepforma } from "../../../assets/logos";
import { noimage } from "../../../assets";

import PopoverNotificacoes from "../../../User/_Aux/PopoverNotificacoes";
import TabelaNotificacoes from "../../../User/_Aux/TabelaNotificacoes";

moment.locale("pt");

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
        iconLoading: false
    });
};

class Navbar extends Component {
    static contextType = GlobalContext;

    state = {
        //ESTABELECIMENTOS E PERFIS
        estabelecimentos: [],
        perfis: [],
        entidade_id: 0,
        entidade_imagem_propria: false,
        entidade_logo: "",
        entidade_nome: "StepForma",
        entidade_nome_abrev: "",
        entidade_afiliado: false,
        entidade_visivel: false,
        entidade_url: "",
        entidade_site: "",
        entidade_chave: "",
        stepmeet_gestao: "",
        entidade_escolas: false,
        categorias: [],
        cursos_stepforma: false,
        acessos: [],
        code: "",
        nome: "",
        foto: "",
        nr_tickets: 0,
        nr_mensagens: 0,
        //FORMADOR
        formador: false,
        tem_licenca: false,
        //MOBILE
        mobile: false,
        //DRAWER CHAT
        mostrarChat: false,
        //DRAWER CARRINHO
        visibleCart: false,
        //LOADING
        iconLoading: false,
        //MENU MOBILE
        menuAdministracaoMobileEstado: [],
        menuGestaoMobileEstado: [],
        menuInstrutorMobileEstado: [],
        menuUtilizadorMobileEstado: ["1"],
        //NOTIFICACOES
        notificacoesVisible: false,
        notificacoesTodasVisible: false,
        notificacoes: [],
        idsNotificacoesParaMarcar: [],

        paginaAtual: 1,
        totalPaginas: 0,
        totalPorLer: 0,

        intervalo: null
    };

    componentDidMount() {
        if (this.context.carrinhoProdutos) {
            this.setState({
                visibleCart: true
            });
        }

        this.carregarUtilizadorInfo();

        if (localStorage.getItem("escola_selecionada")) {
            const estabelecimento = JSON.parse(localStorage.getItem("escola_selecionada"));
            this.context.atualizarState({ estabelecimento });
        }

        if (localStorage.getItem("perfil_selecionado")) {
            const perfil = JSON.parse(localStorage.getItem("perfil_selecionado"));
            this.context.atualizarState({ perfil });
            this.carregarAcessos(perfil?.id);
        }

        this.carregaDadosEntidade();
        this.getNotificacoes();

        this.getNotificacoes(); // chama imediatamente

        this.intervalo = setInterval(() => {
            this.getNotificacoes();
        }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalo); // limpa ao desmontar
    }

    componentDidUpdate() {
        if (this.context.atualizarEntidade) {
            if (localStorage.getItem("escola_selecionada")) {
                const estabelecimento = JSON.parse(localStorage.getItem("escola_selecionada"));
                this.carregarUtilizadorInfo();
                this.context.atualizarState({ estabelecimento });
            }

            if (localStorage.getItem("perfil_selecionado")) {
                const perfil = JSON.parse(localStorage.getItem("perfil_selecionado"));
                this.context.atualizarState({ perfil });
            }

            this.carregaDadosEntidade();
            this.context.atualizarState({ atualizarEntidade: false });
        }
    }

    //Notificacoes
    getNotificacoes = () => {
        axios({
            method: "get",
            url: "api/notificacoes/listar",
            timeout: 60 * 10 * 1000
        })
            .then(response => {
                this.setState({
                    notificacoes: response.data.dados,
                    totalPorLer: response.data.totalPorLer
                });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    marcarComoLido = () => {
        axios({
            method: "POST",
            url: "api/notificacoes/marcar-como-lido",
            data: this.state.idsNotificacoesParaMarcar
        })
            .then(response => {
                this.getNotificacoes();
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    carregarUtilizadorInfo = () => {
        axios({
            method: "get",
            url: "/api/navbar/dados-utilizador",
            timeout: 60 * 10 * 1000
        })
            .then(response => {
                var dados = response.data;

                this.context.atualizarState({
                    id_utilizador: dados.id,
                    foto_utilizador: dados.foto,
                    avatar_utilizador: dados.avatar,
                    nome_utilizador: dados.nome_completo,
                    numero_utilizador: dados.numero,
                    sexo_utilizador: dados.sexo,
                    estabelecimento: dados.estabelecimento,
                    perfil: dados.perfil
                });

                this.carregarEstabelecimentos();
                this.setState({
                    code: dados.code
                });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    carregarTicketsPorLer = () => {
        axios({
            method: "get",
            url: "/api/tickets/total-tickets-por-ler-menu"
        })
            .then(response => {
                this.setState({
                    nr_tickets: response.data
                });
            })
            .catch(error => {});
    };

    decodeHTML = moeda => {
        var map = { gt: ">" /* , … */ };
        return moeda.replace(/&(#(?:x[0-9a-f]+|\d+)|[a-z]+);?/gi, ($0, $1) => {
            if ($1[0] === "#") {
                return String.fromCharCode($1[1].toLowerCase() === "x" ? parseInt($1.substr(2), 16) : parseInt($1.substr(1), 10));
            } else {
                return map.hasOwnProperty($1) ? map[$1] : $0;
            }
        });
    };

    carregaDadosEntidade = () => {
        axios({
            method: "get",
            url: "/api/navbar/dados-entidade"
        })
            .then(response => {
                this.context.atualizarState({
                    id_entidade: response.data.id,
                    nome_entidade: response.data.nome,
                    entidade_abreviatura: response.data.abreviatura,
                    responsaveis_entidade: response.data.responsaveis,
                    formacao_entidade: response.data.formacao,
                    projeto_entidade: response.data.projeto,
                    organizacional_entidade: response.data.organizacional,
                    visivel_entidade: response.data.visivel_entidade,
                    albumId_entidade: response.data.albumId,
                    chave_entidade: response.data.chave_integracao,
                    escolas_entidade: response.data.escolas,
                    login2_entidade: response.data.login2,
                    disciplinas_entidade: response.data.disciplinas,
                    conf_total_participantes: response.data.totalParticipantes,
                    conf_total_recorders: response.data.totalRecorders,
                    monetizacao_entidade: response.data.monetizacao_entidade,
                    monetizacao_stepforma: response.data.monetizacao_stepforma,
                    vendaCursos: response.data.vendaCursos,
                    vendaCertificados: response.data.vendaCertificados,
                    valorMensal: response.data.valorMensal,
                    subscricao_entidade: response.data.subscricao,
                    moeda_entidade: this.decodeHTML(response.data.moeda),
                    gamificacao_entidade: response.data.gamificacao,
                    gamificacao_stepforma: response.data.gamificacao_stepforma,
                    conteudos_animados_entidade: response.data.conteudos_animados,
                    stepmeet_gestao: response.data.stepmeet_gestao,
                    whatsapp_entidade: response.data.whatsapp,
                    reclamacoes_entidade: response.data.reclamacoes,
                    diario_entidade: response.data.diario,
                    diario_stepforma: response.data.diario_stepforma,
                    modulo_formacao_stepforma: response.data.modulo_formacao_stepforma,
                    modulo_formacao: response.data.modulo_formacao,
                    conversas_stepforma: response.data.conversas_stepforma,
                    conversas: response.data.conversas,
                    calendario_stepforma: response.data.calendario_stepforma,
                    calendario: response.data.calendario,
                    relatorios: response.data.relatorios,
                    estatisticas: response.data.estatisticas,
                    eventos: response.data.eventos,
                    stepmeets: response.data.stepmeets,
                    stebinars: response.data.stebinars,
                    newsletter: response.data.newsletter,
                    stepforms: response.data.stepforms
                });

                this.setState({
                    entidade_id: response.data.id,
                    entidade_imagem_propria: response.data.imagem_propria,
                    entidade_logo: response.data.logo,
                    entidade_nome: response.data.nome,
                    entidade_nome_abrev: response.data.nome_abrev,
                    entidade_visivel: response.data.visivel_entidade,
                    entidade_url: response.data.url,
                    entidade_site: response.data.site,
                    entidade_chave: response.data.chave_integracao,
                    stepmeet_gestao: response.data.stepmeet_gestao,
                    entidade_escolas: response.data.escolas
                });

                localStorage.setItem("entidade_id", response.data.id);

                if (response.data.imagem_propria)
                    this.context.atualizarState({
                        favicon_entidade: response.data.logo,
                        title_entidade: response.data.nome
                    });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    onChangeEstabelecimento = estabelecimento => {
        localStorage.setItem("escola_selecionada", JSON.stringify(estabelecimento));
        this.context.atualizarState({
            estabelecimento,
            filtroEstabelecimentosUtilizado: true
        });
        this.carregarPerfis(estabelecimento.id);
    };

    onChangePerfil = perfil => {
        this.context.atualizarState({ perfil });
        this.carregarAcessos(perfil?.id);
    };

    carregarEstabelecimentos = () => {
        axios({
            method: "get",
            url: "/api/navbar/listar-organismos-utilizador"
        })
            .then(response => {
                this.setState(
                    {
                        estabelecimentos: response.data
                    },
                    () => {
                        if (localStorage.getItem("escola_selecionada")) {
                            const estabelecimento = JSON.parse(localStorage.getItem("escola_selecionada"));
                            this.context.atualizarState({ estabelecimento });
                            this.carregarPerfis(estabelecimento.id);
                        } else {
                            const estabelecimento = response.data.find(x => x.principal) || response.data[0];
                            this.context.atualizarState({ estabelecimento });
                            this.carregarPerfis(estabelecimento.id);
                        }

                        this.context.atualizarState({ estabelecimentos: response.data });
                    }
                );
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    carregarPerfis = entidadeId => {
        axios({
            method: "get",
            url: "/api/navbar/listar-perfis-utilizador",
            params: {
                entidadeId
            }
        })
            .then(response => {
                this.setState(
                    {
                        perfis: response.data
                    },
                    () => {
                        const perfil = response.data.find(x => x.principal) || response.data[0];
                        this.context.atualizarState({ perfil });
                        this.carregarAcessos(perfil?.id);
                    }
                );
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    carregarAcessos = perfilId => {
        axios({
            method: "get",
            url: "/api/permissoes/carregar-acessos",
            params: {
                perfilId
            }
        })
            .then(response => {
                this.setState(
                    {
                        acessos: response.data
                    },
                    () => this.context.atualizarState({ acessos: this.state.acessos })
                );
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    logOut = () => {
        this.setState({
            mobile: false,
            iconLoading: true
        });

        axios({
            method: "post",
            url: "/api/autenticacao/logout"
        })
            .then(() => {
                localStorage.removeItem("accessToken");
                delete axios.defaults.headers.common.Authorization;

                localStorage.removeItem("participanteNaMeet");
                this.context.atualizarState({
                    favicon_entidade: "",
                    title_entidade: ""
                });
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro ao sair.");
            })
            .finally(() => {
                this.setState({
                    redirect: true,
                    redirectLink: "/",
                    iconLoading: false
                });
            });
    };

    voltarCarrinho = () => {
        this.setState(
            {
                visibleCart: false
            },
            () => {
                this.context.atualizarState({
                    carrinho: []
                });
            }
        );
    };

    fecharAbrirNotificacoes = visible => {
        this.setState({ notificacoesVisible: visible });
    };

    fecharTodasNotificacoes = () => {
        this.setState({ notificacoesTodasVisible: false });
        this.marcarComoLido();
    };

    atualizarMarcarIdsNotificacoesLidas = ids => {
        this.setState({ idsNotificacoesParaMarcar: ids });
    };

    render() {
        const {
            //ESTABELECIMENTOS E PERFIS
            estabelecimentos,
            entidade_imagem_propria,
            entidade_logo,
            entidade_nome,
            //DRAWER CARRINHO
            visibleCart,
            //REDIRECT
            redirect,
            redirectLink,
            //LOADING
            iconLoading,
            notificacoes,
            notificacoesVisible
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        const menuEstabelecimentos = (
            <Menu className="navbar-opcao-escolas">
                {estabelecimentos.map(estabelecimento => (
                    <Menu.Item
                        key={estabelecimento.id}
                        title={estabelecimento.nome}
                        onClick={() => this.onChangeEstabelecimento(estabelecimento)}
                    >
                        {estabelecimento.abreviatura}
                    </Menu.Item>
                ))}
            </Menu>
        );

        const montarLogoLink = perfilId => {
            if (!perfilId) perfilId = this.context.perfil?.id;

            if (perfilId == 1)
                //SUPORTE
                return "/utilizador";
            else if (perfilId == 2)
                //GESTOR
                return "/utilizador";
            else if (perfilId == 3)
                //ADMINISTRATIVO
                return "/utilizador";
            else if (perfilId == 4)
                //DIRETOR
                return "/utilizador";
            //ALUNO, PROFESSOR E COORDENADOR
            else return "/utilizador";
        };

        const currentPath = window.location.pathname;

        return (
            <div className="navbar-log-in">
                <div className="container container-v2">
                    <Link to={montarLogoLink()} className="brand" title={entidade_nome}>
                        <img
                            src={entidade_imagem_propria ? (entidade_logo ? entidade_logo : noimage) : logo_stepforma}
                            alt="Logo"
                            className="logo"
                        />
                    </Link>
                    <div className="links">
                        {this.state.mobile ? (
                            <ul className="nav-list nav-list-direita nav-list-mobile">
                                <li className="nav-item nav-item-btn">
                                    <Link
                                        to="#"
                                        className="btn-close-nav-list"
                                        onClick={() => this.setState({ mobile: !this.state.mobile })}
                                    >
                                        <Icon type="close" />
                                    </Link>
                                </li>
                                {(currentPath === "/gestao-turmas" || currentPath === "/gestao-ensino-especial") && (
                                    <li className="nav-item">
                                        <Dropdown overlay={menuEstabelecimentos} trigger={["click"]}>
                                            <span className="drop-escola drop-escola-navbar" onClick={e => e.preventDefault()}>
                                                <span className="drop-escola-info">
                                                    <div className="icon-escola">
                                                        <img src={escola} alt="escola" />
                                                    </div>
                                                    <span className="estabelecimento">{this.context.estabelecimento?.abreviatura}</span>
                                                </span>
                                                <Icon type="down" style={{ color: "#2D8D87" }} />
                                            </span>
                                        </Dropdown>
                                    </li>
                                )}

                                {(currentPath !== "/utilizador" ||
                                    this.context.mostrarOptPaginasPublicas ||
                                    this.context.mostrarOptConfiguracoes) && (
                                    <li style={{ marginBottom: 14 }}>
                                        <Link
                                            style={{ fontSize: "18px", paddingTop: 5, paddingBottom: 5, textAlign: "center" }}
                                            className="nav-link botao-inicio "
                                            to="/utilizador"
                                            onClick={() => {
                                                this.context.atualizarState({
                                                    mostrarOptConfiguracoes: false,
                                                    mostrarOptPaginasPublicas: false
                                                });
                                            }}
                                        >
                                            Início
                                        </Link>
                                    </li>
                                )}

                                <button
                                    className="nav-link botao-principal botao-sair"
                                    onClick={this.logOut}
                                    style={{ fontSize: "18px", paddingTop: 5, paddingBottom: 5, textAlign: "center" }}
                                >
                                    <span>
                                        <img src={sair} alt="sair" />
                                    </span>
                                    <span style={{ textTransform: "none" }}>Sair</span>
                                </button>
                            </ul>
                        ) : (
                            <ul className="nav-list nav-list-direita">
                                <div className="sessao-botoes">
                                    <PopoverNotificacoes
                                        abrirTodas={() => {
                                            this.setState({ notificacoesTodasVisible: true });
                                        }}
                                    ></PopoverNotificacoes>
                                    {(currentPath === "/gestao-turmas" || currentPath === "/gestao-ensino-especial") && (
                                        <Dropdown overlay={menuEstabelecimentos} trigger={["click"]}>
                                            <span className="drop-escola drop-escola-navbar" onClick={e => e.preventDefault()}>
                                                <span className="drop-escola-info">
                                                    <div className="icon-escola">
                                                        <img src={escola} alt="escola" />
                                                    </div>
                                                    <span className="estabelecimento">{this.context.estabelecimento?.abreviatura}</span>
                                                </span>
                                                <Icon type="down" style={{ color: "#2D8D87" }} />
                                            </span>
                                        </Dropdown>
                                    )}

                                    {(currentPath !== "/utilizador" ||
                                        this.context.mostrarOptPaginasPublicas ||
                                        this.context.mostrarOptConfiguracoes) && (
                                        <Link
                                            className="nav-link botao-inicio"
                                            to="/utilizador"
                                            onClick={() => {
                                                this.context.atualizarState({
                                                    mostrarOptConfiguracoes: false,
                                                    mostrarOptPaginasPublicas: false
                                                });
                                            }}
                                        >
                                            Início
                                        </Link>
                                    )}
                                    <button
                                        className="nav-link botao-principal botao-sair"
                                        onClick={this.logOut}
                                        style={{ fontSize: "18px", paddingTop: 5, paddingBottom: 5, textAlign: "center" }}
                                    >
                                        <span>
                                            <img src={sair} alt="sair" />
                                        </span>
                                        <span style={{ textTransform: "none" }}>Sair</span>
                                    </button>
                                </div>
                            </ul>
                        )}
                    </div>

                    <div className="burger" onClick={() => this.setState({ mobile: !this.state.mobile })}>
                        <i className="fas fa-bars"></i>
                    </div>
                </div>
                <Modal
                    title="Notificações"
                    visible={this.state.notificacoesTodasVisible}
                    onCancel={this.fecharTodasNotificacoes}
                    footer={null}
                    width={1000}
                >
                    <div className="notificacoes-nav">
                        <TabelaNotificacoes
                            atualizarMarcarIdsNotificacoesLidas={this.atualizarMarcarIdsNotificacoesLidas}
                        ></TabelaNotificacoes>
                    </div>
                </Modal>

                <Modal visible={iconLoading} maskClosable={false} className="modal-loading" footer={null} closable={false}>
                    <div className="modal-loading-bloco">
                        <p>
                            <Icon type="loading" />
                        </p>
                        <p className="texto">A sair...</p>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Navbar);
